import WebApi from "@/views/loyalty/shared/modules/web_api"

export class ReminderEndpointService {
    constructor () {
        // this.url = `${process.env.VUE_APP_LOYALTY_URL}api/reminder/`
        this.url = `${process.env.VUE_APP_NOTIF_URL}api/notification/`
        this.webApi = new WebApi()
    }

    async create_reminder (reminder) {
        const reminder_created = await this.webApi.post(`${this.url}`, reminder)
        if (!reminder_created.status_code) {
            return reminder_created
        } else {
            console.error(`Ошибка с кодом: ${reminder_created.status_code}`)
        }
    }

    async delete_reminder (reminder_id) {
        const reminder = await this.webApi.delete(`${this.url}${reminder_id}`)
        if (!reminder.status_code) {
            return reminder
        } else {
            console.error(`Ошибка с кодом: ${reminder.status_code}`)
        }
    }

    async get_all (clientId, userId, page, limit, filter, search) {
        const reminder = await this.webApi.post(`${this.url}all`, {
            clientId: clientId,
            userId: userId,
            page: page,
            limit: limit,
            filter: filter,
            search: search
        })
        if (!reminder.status_code) {
            return reminder
        } else {
            console.error(`Ошибка с кодом: ${reminder.status_code}`)
            return []
        }
    }

    async get_by_id (reminder_id) {
        const reminder = await this.webApi.get(`${this.url}${reminder_id}`)
        if (!reminder.status_code) {
            return reminder
        } else {
            console.error(`Ошибка с кодом: ${reminder.status_code}`)
        }
    }

    async update_reminder (reminder) {
        const reminder_updated = await this.webApi.put(`${this.url}`, reminder)
        if (reminder_updated.status_code === 200) {
            return reminder_updated.data
        } else {
            console.error(`Ошибка с кодом: ${reminder_updated.status_code}`)
            return reminder_updated
        }
    }
}
